module.exports = __webpack_public_path__ + "static/media/Yvette L.5bdc8044.jpg";